import React, { useEffect, useState } from 'react';
import {
    Button, Form, Input,EditFilled, useSelector,useDispatch
} from './AntComponent';
import { useNavigate, useLocation  } from 'react-router-dom';
import { saveCompanyProfile } from '../store/actions/CompanyProfileAction';
import GarudaLogo from '../assets/images/newlogo.svg';
import ShortLogo from '../assets/images/shortLogo.svg';

export default function CompanyProfile() {
    const [form] = Form.useForm();
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const { profileInfo } = useSelector(state => state.userPrf);
    const cmpProfileData =  profileInfo?.data?.companyProfile
    const tenantID = profileInfo?.data?.appUser?.tenantID;
    const productID = profileInfo?.data?.tenantDetail?.kProductID;
    const RegularSizeImg = `data:image/png;base64,${cmpProfileData?.regularLogobase64Images}`;
    const smallSizeImg = `data:image/png;base64,${cmpProfileData?.smallLogobase64Images}`;
    const [regularImg, setRegularImg] = useState('')
    const [regularImgSize, setRegularImgSize] = useState('')
    const [regularImgName, setRegularImgName] = useState('')
    const [smallImg, setSmallImg] = useState('')
    const [smallImgSize, setSmallImgSize] = useState('')
    const [smallImgName, setSmallImgName] = useState('')
    const [isRegularFile, setIsRegularFile] = useState(false)
    const [isSmallFile, setIsSmallFile] = useState(false)
    const handleBack= () =>{
        navigate(-1)
    }
    useEffect(()=>{
        form.setFieldsValue({
            compName:cmpProfileData?.tenantName ,
            CompAddress: cmpProfileData?.address1 + ", " + cmpProfileData?.address2,
            email:cmpProfileData?.email,
            phone: cmpProfileData?.primaryPhone,
          })
    }, [profileInfo])
    const fileChangeEvent = (event, isRegular, type) => {
        const file = event.target.files[0];
      
        if (file) {
          const reader = new FileReader();
      
          reader.onload = (e) => {
            const base64Image = e.target.result;
            // Extract the name of the file
            const fileName = file.name;
            // Calculate the size of the base64 image
            const binaryImage = atob(base64Image.split(',')[1]);
            const fileSizeInBytes = binaryImage.length;
            console.log(fileSizeInBytes, 'size in byte')
            const fileSizeInKB = fileSizeInBytes / 1024;
            if (type === "large") {
              setRegularImg(base64Image);
              setRegularImgSize(fileSizeInKB);
              setRegularImgName(fileName);
              setIsRegularFile(true)
            } else if(type == "small") {
              setSmallImg(base64Image);
              setSmallImgSize(fileSizeInKB);
              setSmallImgName(fileName);
              setIsSmallFile(true)
            }
          };
          reader.readAsDataURL(file);
        }
      };
      
    const submitForm = (values) =>{
        let inputjson = {
            "TenantProfile": {
                "TenantID": tenantID,
                "Email": values.email,
                "PrimaryPhone": values.phone,
                "ProductID": productID,
            },
            "inputDocs": {
                "RegularLogodocName":regularImgName,
                "RegularLogodocsFile": regularImg ,
                "RegulardocsSize": regularImgSize,
                "SmallLogodocName":smallImgName ,
                "SmallLogodocsFile": smallImg ,
                "SmalldocsSize": smallImgSize
            }
        }
        dispatch(saveCompanyProfile(inputjson))
        console.log(inputjson)
    }

    return(
        <>
            <div className='row m-0 d-flex'>
                <h5 className='w-auto p-2 mt-2'> Company Profile Setting</h5>
                <div className='col-auto ms-auto  text-primary pointer p-2'>
                    <Button type="default" className="ms-auto mb-2" onClick={handleBack}>Back</Button>
                </div>
            </div>
            <div className='row m-0 h-100 mt-2 '>
                <div >
                    <Form
                    className=''
                    form={form}
                    onFinish={submitForm}
                    layout='vertical'
                    >
                        <div className='col-md-12  me-2 p-1 h-100 profile-detail-cont d-flex'>
                            <div className='CompanyProfileFm container col-md-6 bg-white rounded'>
                                <div>
                                    <h5 className='p-2 profileHead'>Company Profile</h5>
                                </div>
                                <div className='row p-3'>
                                    <div className='form-group col-12'>
                                        <Form.Item label="Comapany Name" name="compName" className='col' >
                                            <Input disabled />
                                        </Form.Item>
                                    </div>
                                    <div className='col-12 form-group'>
                                        <Form.Item label="Company Address" name="CompAddress" className='col ' >
                                                <Input disabled />
                                        </Form.Item>
                                    </div>   
                                </div>
                                <div>
                                    <h5 className='p-2 mt-4 profileHead'>Primary Contact</h5>
                                </div>
                                <div className='row p-3'>
                                    <div className='form-group col-12'>
                                        <Form.Item label="Email" name="email" className='col'  >
                                            <Input   />
                                        </Form.Item>
                                    </div>
                                    <div className='col-12 form-group'>
                                        <Form.Item label="Phone" name="phone" className='col ' 
                                         >
                                                <Input  />
                                        </Form.Item>
                                    </div>   
                                </div>
                            </div>
                            <div className=' col-md-6 bg-white container rounded'>
                                <div className=' bg-white me-2 p-3 ps-1 pe-0  pt-0 CompanyImgUpload part2'>
                                    <div className='row p-4 ps-2 pe-0 part1  '>
                                        <h5 className='p-2 profileHead'>Logo - Regular</h5>
                                    </div>
                                    <div className="col-md-12 logo-section">
                                        <div className="row text-center">
                                            <div className="col-md-12">
                                                <label htmlFor="file" className="image-section logo-regular">
                                                    <img src={RegularSizeImg} alt="logo-section" width={179} height={45}/>
                                                    <i className="fas fa-edit me-2 p-1"><EditFilled/></i>
                                                </label>
                                                <p className="mt-5 text-black editContent">
                                                    Click image to edit (Dimension - 179px * 44px)
                                                </p>
                                            </div>
                                            {
                                                isRegularFile &&
                                                <div><h6>Selected File : {regularImgName}</h6></div>
                                            }
                                            <div className="dropzone mb-0 d-flex justify-content-center d-none">
                                                <input
                                                type="file"
                                                name="file"
                                                id="file"
                                                className="inputfile"
                                                accept="image/png,image/jpeg,image/jpg"
                                                onChange={(e) => fileChangeEvent(e, false, "large")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='bg-white me-2 p-3 ps-1 pe-0 pt-0 CompanyImgUpload part2'>
                                    <div className='row p-3 mt-5 ps-2 pe-0 part1  '>
                                        <h5 className='p-2  profileHead'>Logo - small</h5>
                                    </div>
                                    <div className="col-md-12 logo-section">
                                        <div className="row text-center">
                                            <div className="col-md-12">
                                                <label htmlFor="file1" className="image-section1 logo-small">
                                                    <img src={smallSizeImg} alt="logo-section" width={40} height={40}/>
                                                    <i className="fas fa-edit me-2 p-1"><EditFilled/></i>
                                                </label>
                                                <p className="mt-5 text-black editContent">
                                                Click image to edit( Dimension - 40px * 40px )
                                                </p>
                                            </div>
                                            {
                                                isSmallFile && 
                                                <div><h6>Selected File : {smallImgName}</h6></div>
                                            }
                                            <div className="dropzone mb-2 d-flex justify-content-center d-none ">
                                                <input
                                                type="file"
                                                name="file1"
                                                id="file1"
                                                className="inputfile"
                                                accept="image/png,image/jpeg,image/jpg"
                                                onChange={(e) => fileChangeEvent(e, false , "small")}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row m-0 d-flex justify-content-end p-3 mb-2 mt-5'>
                                    <Button className='dlv-save-btn ms-1' type="primary save-btn ms-1" htmlType='submit'>Save</Button>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </>
    )
}